module.exports = __webpack_public_path__ + "img/radio-x.c7599ace.png";